import { Colors, Sizes } from '../../../shared/enums/shared.enums';

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

import { HighlightcardItems } from '../../../shared/interfaces/highlightcard-item.interface';
import { LinkComponent } from '../../atoms/link/link.component';
import LinkType from '../../../shared/enums/link-type.enums';

import { ImageComponent } from '../../atoms/image/image.component';
import HighlightCardType from '../../../shared/enums/highlightcard.type.enums';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-highlightcard',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    LinkComponent,
    ImageComponent,
    CapitalizePipe,
  ],
  templateUrl: './highlightcard.component.html',
  styleUrl: './highlightcard.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class HighlightcardComponent {
  Sizes = Sizes;
  Colors = Colors;
  linkType = LinkType;
  @Input() backgroundColor: Colors = Colors.GREEN;
  @Input() HighlightcardItems: HighlightcardItems[] = [];
  @Input() headerLabel: string = 'highlight';
  @Input() datatype: HighlightCardType = HighlightCardType.HIGHLIGHT;
  @Input() cardBgColor: Colors = Colors.WHITE;
}
